<app-card>
  @if (device) {
    <button
      class="button icon-button absolute-top"
      (click)="closeDetail.emit({ id: device.id })"
    >
      <app-icon name="ic_close" />
    </button>

    <div class="flex flex-1">
      <div>
        <div class="flex wrap">
          <h3 class="line-clamp">
            <app-text-with-icon [name]="device.type | icons">
              {{ device.name }}
            </app-text-with-icon>
          </h3>

          @if (device.isFavorite) {
            <app-icon class="color-favorite" name="ic_star_filled" />
          }

          @if (device.isOutOfService) {
            <app-tag class="ml-2" level="disabled">
              {{ "devices.detail.outOfService.label" | translate }}
            </app-tag>
          }
        </div>

        <div class="flex gap-2">
          @if (device.powerSource) {
            <app-power-item
              [powerSource]="device.powerSource"
              [batteryLevel]="device.batteryLevel"
            />
          }

          @if (device.isActuator) {
            <app-device-action-trigger
              [disabled]="isInteractionDisabled"
              [isActive]="isActive"
              [isPending]="!!device.pendingValue"
              (triggerDeviceAction)="onTriggerDeviceAction($event.value)"
            />
          } @else {
            @if (device.value) {
              <p>
                {{ device.value | localizedNumber }}
                @if (device.valueUnit) {
                  {{
                    LabelConverter.getDeviceValueUnitLabel(
                      device.valueUnit,
                      false
                    ) | translate
                  }}
                }
                <small class="text-light"
                  >({{ device.lastSeenDate | relativeDate }})</small
                >
              </p>
            }
          }
        </div>
      </div>

      <button
        class="button primary-button mt-auto end"
        [routerLink]="getDeviceDetailRoute(device)"
      >
        {{ "map.device.goTo" | translate }}
      </button>
    </div>
  } @else {
    <p>{{ "map.device.empty" | translate }}</p>
  }
</app-card>
